import { usePermissions, useRecordContext, useTranslate } from 'react-admin';
import CustomMorePopover from '@/components/global/buttons/CustomMorePopover.jsx';
import CustomShowModalButton from '@/components/global/buttons/CustomShowModalButton.jsx';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import { useDrawer } from '@/composables/useDrawer';
import { canViewDetails } from '@/helpers/permissions/canViewDetails.js';

export const BrandMoreActions = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const { openDrawer } = useDrawer();

    if (!record?.id || !canViewDetails('brand', permissions)) {
        return null;
    }

    return (
        <CustomMorePopover record={record}>
            <CustomShowModalButton label={translate('resources.brand.labels.show')} onOpen={() => openDrawer(record.id, 'brand-show')} />
            {permissions?.isAdmin ? (
                <CustomEditModalButton label={translate('resources.brand.labels.edit')} onOpen={() => openDrawer(record.id, 'brand-edit')} />
            ) : null}
        </CustomMorePopover>
    );
};

BrandMoreActions.propTypes = {};
